<template>
  <v-container>
    <v-form>
      <v-layout justify-center>
        <v-layout>
          <v-flex>
            <boton-aplicacion></boton-aplicacion>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import BotonAplicacion from "@/modules/configuration/commonsviews/BotonesProcesoAplicacion.vue";

export default {
  components: {
    BotonAplicacion,
  },
  props: {
    proveedor: {},
    show: Boolean,
    tipeView: "",
    contratoId: "",
  },
  data() {
    return {};
  },
  computed: {},
  created() {
    this.nombreProveedor = this.$store.getters.nombreProveedorStored;
    this.$store.commit("tab_state", "Proceso");
  },
  methods: {},
};
</script>
